import styled from 'styled-components';

export const RatingStyles = styled.div`
  margin-left: ${({ ml }) => ml}px;
  .green {
    color: ${({ theme }) => theme.colors.color_green};
  }

  .orange {
    color: ${({ theme }) => theme.colors.color_orange_np};
  }

  .red {
    color: ${({ theme }) => theme.colors.color_red};
  }

  .bold {
    font-weight: bold;
  }
`;
